module.exports = __webpack_public_path__ + "img/ordinary.2a3c8dc6.png";